import config from "@/app/config.js";
import { apiUrlMap, onPremUrlMap } from "@/lib/constants/apiVersions";

export function getApiUrl() {
  return config.VITE_APP_IS_ONPREM === "on" ? onPremUrlMap : apiUrlMap;
}
